import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { KbFileService } from '../myacc-popup-fileService/kbfileService.service';
import { NGXLogger } from "ngx-logger";
@Injectable({
  providedIn: 'root',
})
export class KbWarrantyService {
  constructor(private http: HttpClient, private occService: OccEndpointsService, private kbFileService: KbFileService,
    private logger: NGXLogger
  ) { }

  getWarrantySearch() {
    return this.http.get(this.occService.buildUrl(`mywarranty/getwarrantysearch?`));
  }
  postWarrantySearch(formData, currentPage?, sortType?) {
    if (typeof (sortType) === 'undefined') {
      sortType = 'byDateDesc';
    }
    return this.http.post(
      this.occService.buildUrl(`mywarranty/warrantysearch?currentPage=${currentPage}&sort=${sortType}`),
      formData
    );
  }

  getDealerCode(soldTo: string) {
    return this.http.get(this.occService.buildUrl(`mywarranty/getDealerCode?soldTo=${soldTo}`));
  }

  getSubmitWarranty() {
    return this.http.get(this.occService.buildUrl('mywarranty/getsubmitwarranty'));
  }

  getWarrantyInfo() {
    return this.http.get(this.occService.buildUrl('mywarranty/getwarrantyinfo'));
  }

  submitWarrantyInfo(data) {
    return this.http.post(this.occService.buildUrl('mywarranty/warrantyinfoNA'), data);
  }

  submitWarrantyForReview(data) {
    return this.http.post(this.occService.buildUrl('mywarranty/finalreview'), data);
  }

  finalSubmitWarranty(data) {
    const files = this.kbFileService.filesSubject.getValue();
    const fileMap = files.map((file) => {
      return {
        fileName: file.name,
        fileSize: file.size,
      };
    })
    data.attachmentsInfo = fileMap;
    return this.http.post(this.occService.buildUrl('mywarranty/warrantysubmit'), data);
  }

  getProductForCustomPart(code: string, soldTo: string) {
    return this.http.get(this.occService.buildUrl('mywarranty/getProductForCustomPartNA'), {
      params: {
        code: `${code}, ${soldTo}`,
      },
    });
  }

  testWarrentyAPINA(json) {
    const files = this.kbFileService.filesSubject.getValue();
    const fileMap = files.map((file) => {
      return {
        fileName: file.name,
        fileSize: file.size,
      };
    })
    json.attachmentsInfo = fileMap;
    const formData = new FormData();
    formData.append('json', JSON.stringify(json));
    if (files?.length === 0) {
      formData.append('file', null);
    }
    else {
      files?.forEach((file) => {
        formData.append('file', file || null);
      });
    }
    this.logger.info("TestAPINA", formData);
    return this.http.post(this.occService.buildUrl('mywarranty/uploadtest?'), formData);
  }
}
